import { Reveal, Eyebrow } from "./Reveal";

const LOGOS = [
    { name: "KEI Wires & Cables", src: "/brands/kei.png", alt: "KEI Industries logo" },
    { name: "Polycab Wires & Cables", src: "/brands/polycab.png", alt: "Polycab India logo" },
    { name: "Havells Wires & Cables", src: "/brands/havells.png", alt: "Havells India logo" },
];

const MORE = ["DOWELLS", "RAYCHEM RPG", "3M", "FINOLEX", "RR KABEL", "GLOSTER", "ULTRACAB"];

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export default function BrandWall() {
    return (
        <section id="brands" className="relative hud-bg py-20 lg:py-28 border-y border-line" data-testid="brand-wall-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-12">
                    <Reveal>
                        <Eyebrow className="mb-5">08 — Authorised Stock</Eyebrow>
                        <h2 className="font-display font-bold tracking-tight leading-[1.05] text-3xl sm:text-4xl lg:text-5xl text-ink">
                            The brands on <em className="text-copper">our racks.</em>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.15} className="md:max-w-sm">
                        <p className="text-mist leading-relaxed">
                            Genuine material, straight from authorised channels — with mill test
                            certificates on every lot.
                        </p>
                    </Reveal>
                </div>

                <div className="grid sm:grid-cols-3 gap-4 mb-10">
                    {LOGOS.map((b, i) => (
                        <Reveal key={b.name} delay={i * 0.08}>
                            <div
                                data-testid={`brand-logo-${slug(b.name)}`}
                                className="rounded-md border border-line bg-white p-8 shadow-sm hover:shadow-xl hover:border-copper/40 hover:-translate-y-1 transition-all duration-500 flex flex-col items-center justify-center text-center h-full"
                            >
                                <img src={b.src} alt={b.alt} className="h-14 md:h-16 object-contain mb-5" />
                                <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-dim">
                                    {b.name}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.1}>
                    <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-dim mb-4">
                        Also stocking
                    </p>
                    <div className="flex flex-wrap gap-2" data-testid="brand-chips">
                        {MORE.map((b) => (
                            <span
                                key={b}
                                className="font-mono text-[10px] tracking-[0.15em] uppercase border border-line bg-white px-4 py-2 rounded-full text-mist hover:border-copper hover:text-copper transition-colors duration-300"
                            >
                                {b}
                            </span>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
